export const AMS_CHANNEL = {
  1: 'weixin',
  2: 'qq',
};

export const AMS_SYSTEM = {
  IOS: '0',
  ANDROID: '1',
};

export const MSDK_SYSTEM = {
  1: AMS_SYSTEM.ANDROID,
  2: AMS_SYSTEM.IOS,
  0: AMS_SYSTEM.IOS,
};
